import React from 'react';

import {Box, Card, CardContent, CardHeader, Stack, TextField, Typography} from '@mui/material';
import {useQuery} from 'react-query';

import API, {MissionGetProps, Types} from '@wheeebo/polaris-api';
import {CircleLoader, GroupPanel, LoadError} from '@wheeebo/polaris-ui';

interface Props {
  missionId: Types.UUID;
  onGroupSelected: (groupId: Types.UUID) => void;
}

const MeissionProfileCard = ({missionId, onGroupSelected}: Props): JSX.Element => {
  const options: MissionGetProps = {preload: ['group']};
  const {data, isLoading, isError} = useQuery(API.Missions.getKey(missionId, options), () =>
    API.Missions.get(missionId, options),
  );
  return (
    <Card variant="outlined" sx={{zIndex: 1}}>
      <CardHeader title="Mission Profile" />
      <CardContent>
        {isLoading ? <CircleLoader /> : null}
        {isError ? <LoadError /> : null}
        {data ? (
          <Stack gap={1}>
            <Box>
              <Typography variant="caption">Group</Typography>
              <GroupPanel group={data.group} onClick={() => onGroupSelected(data.group.id)} />
            </Box>
            <TextField disabled fullWidth variant="standard" label="Mission ID" value={missionId} />
            <TextField disabled fullWidth variant="standard" label="Name" value={data?.name || ''} />
            <TextField
              disabled
              fullWidth
              variant="standard"
              label="Description"
              multiline
              value={data?.description || ''}
            />
            <TextField
              disabled
              fullWidth
              variant="standard"
              label="Start Date"
              value={data?.startAt ? new Date(data?.startAt).toISOString().split('.')[0] : 'N/A'}
            />
            <TextField
              disabled
              fullWidth
              variant="standard"
              label="Name"
              value={data?.endAt ? new Date(data?.endAt).toISOString().split('.')[0] : 'N/A'}
            />
          </Stack>
        ) : (
          <Typography variant="body2">No record found.</Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(MeissionProfileCard);
